import { SpellCheckTextbox } from './SpellCheckTextbox';

/**
 * Clear all spell check errors from all textboxes on the canvas
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 */
export function clearAllSpellCheckErrors(canvas) {
  if (!canvas) {
    return;
  }

  // Get all objects from the canvas
  const objects = canvas.getObjects();

  // Iterate through all objects
  objects.forEach((obj) => {
    // Check if the object is a SpellCheckTextbox
    if (obj instanceof SpellCheckTextbox) {
      // Clear spell check results
      obj.clearSpellCheckResults();
    }
  });

  // Request a render to update the canvas
  canvas.requestRenderAll();
}
